const L = {
  name: "OmnichannelExperiences",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.25 3C13.25 3.69 12.69 4.25 12 4.25C11.31 4.25 10.75 3.69 10.75 3C10.75 2.31 11.31 1.75 12 1.75C12.69 1.75 13.25 2.31 13.25 3Z" fill="currentColor"/>
<path d="M9.66811 9.90254L11.5513 6.1206L9.76097 5.22913L8.33267 8.09752L1.03711 9.31345L6.40123 15.2736L5.75772 17.8476L7.698 18.3327L8.59956 14.7265L4.96368 10.6866L9.66811 9.90254Z" fill="currentColor"/>
<path d="M15.7713 18.7606L12.0004 16.8829L8.22949 18.7606L9.12097 20.551L12.0004 19.1172L14.8798 20.551L15.7713 18.7606Z" fill="currentColor"/>
<path d="M14.2395 5.22913L15.6678 8.09752L22.9634 9.31345L17.6012 15.2715L18.256 17.8423L16.3179 18.3359L15.3991 14.7286L19.0368 10.6866L14.3324 9.90254L12.4492 6.1206L14.2395 5.22913Z" fill="currentColor"/>
<path d="M19.25 21C19.25 21.69 18.69 22.25 18 22.25C17.31 22.25 16.75 21.69 16.75 21C16.75 20.31 17.31 19.75 18 19.75C18.69 19.75 19.25 20.31 19.25 21Z" fill="currentColor"/>
<path d="M6 22.25C6.69 22.25 7.25 21.69 7.25 21C7.25 20.31 6.69 19.75 6 19.75C5.31 19.75 4.75 20.31 4.75 21C4.75 21.69 5.31 22.25 6 22.25Z" fill="currentColor"/>
</svg>
  `
};
export {
  L as OmnichannelExperiences
};
